// src/components/common/InfoTooltip.jsx
import { Tooltip, TooltipProvider } from "../components/ui/Tooltip";
import { HelpCircle } from "lucide-react";

const PlanTypeInfoTooltip_v1 = () => {
  return (
    <TooltipProvider>
      <Tooltip
        content={
          <div className="max-w-xs sm:max-w-md text-sm sm:text-base space-y-4">
            <p className="text-white-600 leading-relaxed">
              When enrolling a new member, the plan availability depends on
              their member type:
            </p>
            <ul className="list-none space-y-3">
              <li className="grid grid-cols-[80px_1fr] items-start gap-2">
                <span className="inline-block px-2 py-1 text-xs font-semibold text-blue-800 bg-blue-100 rounded-full text-center">
                  Principal
                </span>
                <span className="pt-1">
                  This plan is available for new members with Principal type.
                </span>
              </li>
              <li className="grid grid-cols-[80px_1fr] items-start gap-2">
                <span className="inline-block px-2 py-1 text-xs font-semibold text-green-800 bg-green-100 rounded-full text-center">
                  Dependent
                </span>
                <span className="pt-1">
                  This plan is available only for new members with Dependent
                  type.
                </span>
              </li>
              <li className="grid grid-cols-[80px_1fr] items-start gap-2">
                <span className="inline-block px-2 py-1 text-xs font-semibold text-purple-800 bg-purple-100 rounded-full text-center">
                  Both
                </span>
                <span className="pt-1">
                  This plan can be used by new members whether Principal or
                  Dependent.
                </span>
              </li>
            </ul>
          </div>
        }
      >
        <HelpCircle className="h-4 w-4 text-gray-500 cursor-pointer" />
      </Tooltip>
    </TooltipProvider>
  );
};

export default PlanTypeInfoTooltip_v1;
